import { ReactComponent as Arrow } from './arrow.svg'
import { ReactComponent as Bell } from './bell.svg'
import { ReactComponent as BoldPin } from './bold-pin.svg'
import { ReactComponent as Calendar } from './calendar.svg'
import { ReactComponent as Camera } from './camera.svg'
import { ReactComponent as Check } from './check.svg'
import { ReactComponent as CircledPlus } from './circled-plus.svg'
import { ReactComponent as Clock } from './clock.svg'
import { ReactComponent as ClockOrange } from './clock-orange.svg'
import { ReactComponent as Close } from './close.svg'
import { ReactComponent as CoachNow } from './coach-now.svg'
import { ReactComponent as Division } from './division.svg'
import { ReactComponent as Dollar } from './dollar.svg'
import { ReactComponent as DollarCoin } from './dollar-coin.svg'
import { ReactComponent as DollarText } from './dollar-text.svg'
import { ReactComponent as Download } from './download.svg'
import { ReactComponent as External } from './external.svg'
import { ReactComponent as ExternalGlobe } from './external-globe.svg'
import { ReactComponent as Facebook } from './facebook.svg'
import { ReactComponent as FiletypeXLS } from './filetype-xls.svg'
import { ReactComponent as FiletypeXLSX } from './filetype-xlsx.svg'
import { ReactComponent as FiletypeCSV } from './filetype-csv.svg'
import { ReactComponent as Filter } from './filter.svg'
import { ReactComponent as Caret } from './caret.svg'
import { ReactComponent as GolfBall } from './golf-ball.svg'
import { ReactComponent as GolfFlag } from './golf-flag.svg'
import { ReactComponent as GolfFlagOrange } from './golf-flag-orange.svg'
import { ReactComponent as GolfFormat } from './golf-format.svg'
import { ReactComponent as Google } from './google.svg'
import { ReactComponent as HandicapIndex } from './handicap-index.svg'
import { ReactComponent as Heart } from './heart.svg'
import { ReactComponent as HeartFilled } from './heart-filled.svg'
import { ReactComponent as Info } from './info.svg'
import { ReactComponent as Instagram } from './instagram.svg'
import { ReactComponent as Leaderboard } from './leaderboard.svg'
import { ReactComponent as Link } from './link.svg'
import { ReactComponent as Linkedin } from './linkedin.svg'
import { ReactComponent as LongArrow } from './long-arrow.svg'
import { ReactComponent as Locate } from './locate.svg'
import { ReactComponent as MailEnvelope } from './mail-envelope.svg'
import { ReactComponent as Map } from './map.svg'
import { ReactComponent as MapOrange } from './map-orange.svg'
import { ReactComponent as MapPin } from './map-pin.svg'
import { ReactComponent as MapPinFilled } from './map-pin-filled.svg'
import { ReactComponent as MapPinTransparent } from './map-pin-transparent.svg'
import { ReactComponent as MemoPencil } from './memo-pencil.svg'
import { ReactComponent as OpenedMap } from './opened-map.svg'
import { ReactComponent as Operation36 } from './operation-36.svg'
import { ReactComponent as PercentFlower } from './percent-flower.svg'
import { ReactComponent as PlayVideo } from './play-video.svg'
import { ReactComponent as Price } from './price.svg'
import { ReactComponent as Print } from './print.svg'
import { ReactComponent as Scorecard } from './scorecard.svg'
import { ReactComponent as Search } from './search.svg'
import { ReactComponent as Share } from './share.svg'
import { ReactComponent as ShareUp } from './share-up.svg'
import { ReactComponent as Shuffle } from './shuffle.svg'
import { ReactComponent as SwapOrange } from './swap-orange.svg'
import { ReactComponent as Twitter } from './twitter.svg'
import { ReactComponent as UpLadderOrange } from './up-ladder-orange.svg'
import { ReactComponent as Users } from './users.svg'
import { ReactComponent as Warning } from './warning.svg'
import { ReactComponent as Grid } from './grid.svg'
import { ReactComponent as List } from './list.svg'
import { ReactComponent as SortBy } from './sort-by.svg'

export default {
  grid: Grid,
  list: List,
  caret: Caret,
  arrow: Arrow,
  bell: Bell,
  'bold-pin': BoldPin,
  'sort-by': SortBy,
  calendar: Calendar,
  camera: Camera,
  check: Check,
  'circled-plus': CircledPlus,
  clock: Clock,
  'clock-orange': ClockOrange,
  'close-icon': Close,
  'coach-now': CoachNow,
  division: Division,
  dollar: Dollar,
  'dollar-coin': DollarCoin,
  'dollar-text': DollarText,
  download: Download,
  external: External,
  'external-globe': ExternalGlobe,
  facebook: Facebook,
  'filetype-xls': FiletypeXLS,
  'filetype-xlsx': FiletypeXLSX,
  'filetype-csv': FiletypeCSV,
  filter: Filter,
  'golf-ball': GolfBall,
  'golf-flag': GolfFlag,
  'golf-flag-orange': GolfFlagOrange,
  'golf-format': GolfFormat,
  google: Google,
  'handicap-index': HandicapIndex,
  heart: Heart,
  'heart-filled': HeartFilled,
  info: Info,
  instagram: Instagram,
  leaderboard: Leaderboard,
  link: Link,
  'long-arrow': LongArrow,
  linkedin: Linkedin,
  locate: Locate,
  'mail-envelope': MailEnvelope,
  map: Map,
  'map-orange': MapOrange,
  'map-pin': MapPin,
  'map-pin-filled': MapPinFilled,
  'map-pin-transparent': MapPinTransparent,
  'memo-pencil': MemoPencil,
  'opened-map': OpenedMap,
  'operation-36': Operation36,
  'percent-flower': PercentFlower,
  'play-video': PlayVideo,
  price: Price,
  print: Print,
  scorecard: Scorecard,
  search: Search,
  'share-up': ShareUp,
  share: Share,
  shuffle: Shuffle,
  'swap-orange': SwapOrange,
  twitter: Twitter,
  'up-ladder-orange': UpLadderOrange,
  users: Users,
  warning: Warning,
}
